import React, { useState } from "react";
import { Topbar, Alert } from "@components";
import { useNavigate } from "react-router-dom";
import {
  ChangePinContainer,
  ChangePinTitle,
  Button,
  Form,
  ChangePinLabel,
} from "./ChangePin.style";
// import { Form } from "antd";
import { PUBLIC_ROUTE } from "@router/route.constants";
import { api } from "@api";
import { useTranslation } from "react-i18next";
import { useDispatch } from "react-redux";
import { openAlert } from "@redux/app/appSlice";
import { InputPassword } from "@components";

const ChangePin = () => {
  const { t } = useTranslation();
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const [loading, setLoading] = useState(false);

  const goBack = () => {
    navigate(`/${PUBLIC_ROUTE.HOME}/${PUBLIC_ROUTE.PROFILE}`);
  };

  const onFinish = (data) => {
    if (!loading) {
      if (data.new_pin !== data.confirm_pin) {
        showAlert({
          message: t("profile.newAndConfirmPinDoNotMatch"),
          isError: true,
        });
        return;
      }
      setLoading(true);
      api
        .updatePin(data)
        .then(() => {
          setLoading(false);
          showAlert({
            message: t("common.updateSuccessMessage"),
            successCallback: goBack,
          });
        })
        .catch((errorMsg) => {
          setLoading(false);
          showAlert({
            message: errorMsg,
            isError: true,
          });
        });
    }
  };

  const showAlert = (data) => {
    dispatch(openAlert(data));
  };

  return (
    <>
      <Topbar title={t("profile.changePin")} goBack={goBack} />
      <ChangePinContainer>
        <ChangePinTitle>{t("profile.changePinHeading")}</ChangePinTitle>
        <ChangePinLabel>{t("profile.changePinHeadLabel")}</ChangePinLabel>
        <Form
          style={{
            width: "100%",
            textAlign: "center",
          }}
          layout="vertical"
          onFinish={onFinish}
          requiredMark={false}
        >
          <Form.Item
            name="old_pin"
            label={t("profile.changePinLabelOldPin")}
            rules={[
              {
                required: true,
                message: "",
              },
              {
                pattern: /^[0-9]{6}$/,
                message: t("profile.oldPinValidateMessage"),
              },
            ]}
          >
            <InputPassword placeholder={t("profile.enterOldPin")} />
          </Form.Item>
          <Form.Item
            name="new_pin"
            label={t("profile.changePinLabelNewPin")}
            rules={[
              {
                required: true,
                message: "",
              },
              {
                pattern: /^[0-9]{6}$/,
                message: t("profile.newPinValidateMessage"),
              },
            ]}
          >
            <InputPassword placeholder={t("profile.enterNewPin")} />
          </Form.Item>
          <Form.Item
            name="confirm_pin"
            label={t("profile.changePinLabelConfirmPin")}
            rules={[
              {
                required: true,
                message: "",
              },
              {
                pattern: /^[0-9]{6}$/,
                message: t("profile.confirmPinValidateMessage"),
              },
            ]}
          >
            <InputPassword placeholder={t("profile.enterConfirmNewPin")} />
          </Form.Item>
          <Form.Item>
            <Button
              type="primary"
              size="large"
              htmlType="submit"
              loading={loading}
            >
              {t("common.save")}
            </Button>
          </Form.Item>
        </Form>
      </ChangePinContainer>
      <Alert />
    </>
  );
};

export default ChangePin;
